import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mediaSeconds',
    standalone: false
})
export class MediaSecondsPipe implements PipeTransform {

  transform(seconds: number | string) {
    if (typeof seconds === 'string')
      seconds = parseInt(seconds);

    if (isNaN(seconds) || seconds < 0)
      return '0:00';

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    const res = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    return res;
  }
}
